module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('transition', [_c('div', {
    class: _vm.classObject,
    style: (_vm.styleObject),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.value,
      "aria-valuemin": 0,
      "aria-valuemax": _vm.max
    }
  }, [_vm._t("default", [(_vm.showProgress) ? [_vm._v(_vm._s(_vm.progress) + "%")] : (_vm.showValue) ? [_vm._v(_vm._s(_vm.value))] : _vm._e()])], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38fb440c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/progress.vue
// module id = 233
// module chunks = 0